import api from './api';

export interface TipoFormulario {
    nota?: string;
    nroTipoFormulario: string;
    descripcion: string;
    area: string;
    utilizaLibroIva: string;
    sumaResta: string;
    stockNegativo: number;
    infoCons?: number;
    descuentaStock?: number;
}

export interface TipoFormularioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    nroTipoFormulario?: string;
    descripcion?: string;
    area?: string;
}

export interface TipoFormularioPagedResult {
    items: TipoFormulario[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const tipoFormularioService = {
    getTipoFormularios: async (params: TipoFormularioSearchParams): Promise<TipoFormularioPagedResult> => {
        const response = await api.get<TipoFormularioPagedResult>('/api/TipoFormulario', { params });
        return response.data;
    },

    getTipoFormulario: async (nroTipoFormulario: string): Promise<TipoFormulario> => {
        const response = await api.get<TipoFormulario>(`/api/TipoFormulario/${nroTipoFormulario}`);
        return response.data;
    },

    createTipoFormulario: async (tipoFormulario: TipoFormulario): Promise<TipoFormulario> => {
        const response = await api.post<TipoFormulario>('/api/TipoFormulario', tipoFormulario);
        return response.data;
    },

    updateTipoFormulario: async (nroTipoFormulario: string, tipoFormulario: TipoFormulario): Promise<void> => {
        await api.put(`/api/TipoFormulario/${nroTipoFormulario}`, tipoFormulario);
    },

    deleteTipoFormulario: async (nroTipoFormulario: string): Promise<void> => {
        await api.delete(`/api/TipoFormulario/${nroTipoFormulario}`);
    }
};

export default tipoFormularioService;
